// src/components/finance/steps/ApplicantStep.jsx
import React, { useState } from 'react';
import '../../../styles/LoanSteps.css';

const ApplicantStep = ({ data, onNext, onPrevious, loading }) => {
  const [formData, setFormData] = useState({
    full_name: data.full_name || '',
    email: data.email || '',
    dob: data.dob || '',
    gender: data.gender || '',
    mobile: data.mobile || ''
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    
    if (!formData.full_name.trim()) newErrors.full_name = 'Name is required';
    if (!formData.email.includes('@')) newErrors.email = 'Valid email required';
    if (!formData.dob) newErrors.dob = 'Date of birth required';
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!/^\d{10}$/.test(formData.mobile)) newErrors.mobile = 'Valid 10-digit mobile required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onNext(formData);
    }
  };

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <h3>Hey, {data.pan}!</h3>
        <p>Tell us a bit more about yourself</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form">
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            value={formData.full_name}
            onChange={(e) => handleChange('full_name', e.target.value)}
            placeholder="Your full name"
            className={errors.full_name ? 'error' : ''}
          />
          {errors.full_name && <span className="error-text">{errors.full_name}</span>}
        </div>

        <div className="form-group">
          <label>Email Address</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="your@email.com"
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Date of Birth</label>
            <input
              type="date"
              value={formData.dob}
              onChange={(e) => handleChange('dob', e.target.value)}
              className={errors.dob ? 'error' : ''}
            />
            {errors.dob && <span className="error-text">{errors.dob}</span>}
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select
              value={formData.gender}
              onChange={(e) => handleChange('gender', e.target.value)}
              className={errors.gender ? 'error' : ''}
            >
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            {errors.gender && <span className="error-text">{errors.gender}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>Mobile Number</label>
          <input
            type="tel"
            value={formData.mobile}
            onChange={(e) => handleChange('mobile', e.target.value)}
            placeholder="mobile number"
            maxLength={10}
            className={errors.mobile ? 'error' : ''}
          />
          {errors.mobile && <span className="error-text">{errors.mobile}</span>}
        </div>

        <div className="button-group">
          <button type="button" onClick={onPrevious} className="previous-button">
            Previous
          </button>
          <button type="submit" className="next-button" disabled={loading}>
            {loading ? 'Processing...' : 'Next'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ApplicantStep;